<template>
  <div class="realize_wrap">
    <div class="realize_img">
      <div class="img_tit">
        <i :class="calcClass">{{$t("nav.portfolioCompanies")}}</i>
        <div class="img_desc">{{$t("homeAbout.portfolioCompaniesEn")}}
      </div>
    </div>
    </div>
    <!--公司介绍-->
    <div class="introduced">
      <div class="company">
        <div class="title">{{$t("homeAbout.company2")}}</div>
        <div class="website" @click="handleJump('http://m.zhaoshangbang.com')">http://m.zhaoshangbang.com</div>
        <div class="code">{{$t("companies.Code")}} ZSBS</div>
      </div>
      <div class="profile">
        <div class="profile-right" v-animate-on-scroll="'animate__backInRight'">
          <div class="profile-left" v-animate-on-scroll="'animate__backInLeft'">
            <img src="@/assets/img/other/1746612104_LtNQ.png" alt="">
          </div>
          <span class="presented">
            <span class="presented-title">{{$t("companies.presentedTitle")}}</span>
            <span class="presented-sub">{{$t("companies.presentedSubtitle")}}</span>
          </span>
          <span class="describe">
            <strong>{{$t("whzsbkj.describeTitle")}}</strong>
            {{$t("whzsbkj.describeContent")}}
          </span>
        </div>
      </div>
    </div>
    <!--服务内容-->
    <div class="service-content">
      <div class="header">
        <strong class="title">{{$t("whzsbkj.serviceTitle")}}</strong>
        <div class="sub">{{$t("whzsbkj.serviceSubtitle")}}</div>
      </div>
      <div class="service-info">
        <div class="pc-img">
          <img :src="getImg1()" alt=""/>
        </div>
        <div class="cell-phone">
          <img :src="getImg2()" alt=""/>
          <img :src="getImg3()" alt=""/>
        </div>
      </div>
    </div>
    <!-- 我们代理、合作以下媒体-->
    <div class="partners">
      <img :src="getImg4()" alt="">
    </div>
    <!--10大服务体系-->
    <div class="service-system">
      <img :src="getImg5()" alt=""/>
    </div>
    <!--对标上市企业-->
    <div class="benchmarking">
      <div class="header">
        <strong class="title">{{$t("companies.benchmarkingTitle")}}</strong>
        <div class="sub">{{$t("companies.benchmarkingSubtitle")}}</div>
      </div>
      <div class="profile">
        <div class="profile-right" v-animate-on-scroll="'animate__backInRight'">
          <div class="profile-left" v-animate-on-scroll="'animate__backInLeft'">
            <img src="@/assets/img/other/1745577907_XQ8R.jpg" alt="">
          </div>
          <span class="presented">
            <span class="presented-title">{{$t("whzsbkj.presentedTitle")}}</span>
            <span class="presented-sub">{{$t("whzsbkj.presentedSubtitle")}}</span>
          </span>
          <span class="describe">
            {{$t("whzsbkj.presentedDescribe")}}
          </span>
        </div>
      </div>
    </div>
    <CallMe />
  </div>
</template>

<script>
/* eslint-disable */
import CarouselImg from "@/components/portfolio-companies/Carousel.vue";
import CallMe from '@/components/callme/index'
export default {
  computed:{
    calcClass()
    {
      return (this.$i18n.locale === 'en' || this.$i18n.locale === 'ar') ? 'english-layout' : '';
    },
    locale()
    {
      return this.$i18n.locale
    }
  },
  data() {
    return {}
  },
  methods: {
    getImg1()
    {
      if(this.locale === "zh-CN")
      {
        return require("@/assets/img/other/1746613244_L7jy.jpg")
      }
      else if(this.locale === "zh-TW")
      {
        return require("@/assets/img/other/1746613244_L7jy_tw.jpg")
      }
      else if(this.locale === "en")
      {
        return require("@/assets/img/other/1746613244_L7jy_en.jpg")
      }
      else if(this.locale === "ar")
      {
        return require("@/assets/img/other/1746613244_L7jy_ar.jpg")
      }
    },
    getImg2()
    {
      if(this.locale === "zh-CN")
      {
        return require("@/assets/img/other/1749030619_B2Hk.png")
      }
      else if(this.locale === "zh-TW")
      {
        return require("@/assets/img/other/1749030619_B2Hk_tw.png")
      }
      else if(this.locale === "en")
      {
        return require("@/assets/img/other/1749030619_B2Hk_en.png")
      }
      else if(this.locale === "ar")
      {
        return require("@/assets/img/other/1749030619_B2Hk_ar.png")
      }
    },
    getImg3()
    {
      if(this.locale === "zh-CN")
      {
        return require("@/assets/img/other/1749030690_KnmI.png")
      }
      else if(this.locale === "zh-TW")
      {
        return require("@/assets/img/other/1749030690_KnmI_tw.png")
      }
      else if(this.locale === "en")
      {
        return require("@/assets/img/other/1749030690_KnmI_en.png")
      }
      else if(this.locale === "ar")
      {
        return require("@/assets/img/other/1749030690_KnmI_ar.png")
      }
    },
    getImg4()
    {
      if(this.locale === "zh-CN")
      {
        return require("@/assets/img/other/1746613731_O0PH.png")
      }
      else if(this.locale === "zh-TW")
      {
        return require("@/assets/img/other/1746613731_O0PH_tw.png")
      }
      else if(this.locale === "en")
      {
        return require("@/assets/img/other/1746613731_O0PH_en.png")
      }
      else if(this.locale === "ar")
      {
        return require("@/assets/img/other/1746613731_O0PH_ar.png")
      }
    },
    getImg5()
    {
      if(this.locale === "zh-CN")
      {
        return require("@/assets/img/other/1746613794_9oZT.png")
      }
      else if(this.locale === "zh-TW")
      {
        return require("@/assets/img/other/1746613794_9oZT_tw.png")
      }
      else if(this.locale === "en")
      {
        return require("@/assets/img/other/1746613794_9oZT_en.png")
      }
      else if(this.locale === "ar")
      {
        return require("@/assets/img/other/1746613794_9oZT_ar.png")
      }
    },
    handleJump(src)
    {
      window.open(src, '_blank')
    }
  },
  components: {
    CallMe,
    CarouselImg
  },
  created(){
    this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
  },
  mounted() {
  },
  watch: {
    $route() {
      this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
    },
  },
}
</script>

<style lang="scss" scoped>
.realize_wrap {
  position: relative;
  background-color: #fff;
  font-family: $font-family;
  .realize_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background-image: url('../../assets/img/other/1749520018_lP3M.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    .img_tit {
      width: 70%;
      font-weight: bold;
      margin: 0 auto;
      transition: all 0.5s ease 0s;

      i {
        font-size: $banner-font-size;
        border-bottom: 4px #fff solid;
        padding-bottom: 10px;
        @media screen and (max-width: 768px) {
          font-size: $phone-banner-font-size;
        }
      }
    }

    .img_desc {
      font-size: $banner-sub-font-size;
      margin-top: 15px;
      text-transform: uppercase;
      @media screen and (max-width: 768px) {
        font-size: $phone-banner-sub-font-size;
      }
      outline: none;
    }
  }
  .company{
    text-align: center;
    padding: 40px 0 20px 0;
    @media screen and (max-width: 768px) {
      padding: 2rem 0 1rem 0
    }
    .title{
      font-size: $company-font-size;
      font-weight: bold;
      color: #000000;
      @media screen and (max-width: 768px) {
        font-size: $phone-company-font-size;
      }
    }
    .website{
      font-size: $web-font-size;
      color: #333333;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        font-size: $phone-web-font-size;
        padding: 0.3rem 0;
      }
    }
    .code{
      font-size: $code-font-size;
      color: #fccc0c;
      @media screen and (max-width: 768px) {
        font-size: $phone-code-font-size;
      }
    }
  }
  .header{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      padding:1.2rem 0;
    }
    .title{
      font-size:$title-font-size;
      color:#000000;
      @media screen and (max-width: 768px) {
        font-size: $phone-title-font-size;
      }
    }
    .sub{
      /*margin-top: 2px;*/
      font-size:$subtitle-font-size;
      color:#fccc0c;
      @media screen and (max-width: 768px) {
        margin-top: 0.2rem;
        font-size: 0.8rem;
      }
    }
  }
  //公司介绍
  .introduced{
    .company{
      text-align: center;
      padding: 40px 0 20px 0;
      @media screen and (max-width: 768px) {
        padding: 2rem 0 1rem 0
      }
      .title{
        font-size: $company-font-size;
        font-weight: bold;
        color: #000000;
        @media screen and (max-width: 768px) {
          font-size: $phone-company-font-size;
        }
      }
      .website{
        font-size: $web-font-size;
        color: #333333;
        cursor: pointer;
        padding: 0.3rem 0;
        @media screen and (max-width: 768px) {
          font-size: $phone-web-font-size;
        }
      }
      .code{
        font-size: $code-font-size;
        color: #fccc0c;
        @media screen and (max-width: 768px) {
          font-size: $phone-code-font-size;
        }
      }
    }
  }
  .profile{
    position: relative;
    width: 70%;
    margin:0 auto;
    padding-bottom: 50px;
    @media screen and (max-width: 768px) {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
    .profile-left{
      float: left;
      overflow: hidden;
      position: relative;
      height: 360px;
      width: 560px;
      margin-right: 30px;
      @media screen and (max-width: 768px) {
        height: 20rem;
        width: 100%;
        margin: 0;

      }
      img{
        height: 100%;
        width: 100%;
        border-radius: 10px;
      }
    }
    .profile-right{
      margin-top: 25px;
      margin-left: 40px;
      @media screen and (max-width: 768px) {
        display: flex;
        flex-direction: column;
        margin: 0 0.8rem;
      }
      .presented{
        display: flex;
        flex-direction: column;
        font-size: 1.8rem;
        font-weight: bold;
        color: #000000;
        @media screen and (max-width: 768px) {
          font-size: 1.3rem;
          align-items: center;
          padding: 1rem 0;
        }
        .presented-sub{
          font-size: 1.2rem;
          color: #fccc0c;
          font-weight: normal;
          @media screen and (max-width: 768px) {
            font-size: 0.8rem;
          }
        }
      }
      .describe{
        width: 550px;
        font-size: $content-font-size;
        color: #000000;
        line-height: 2;
        margin-top: 5px;
        @media screen and (max-width: 768px) {
          font-size: $phone-content-font-size;
          width: 100%;
        }
      }
      li{
        list-style-type: none;
      }
      .decision{
        font-size: 15px;
        color: #000000;
        line-height: 2;
        @media screen and (max-width: 768px) {
          font-size: 0.8rem;
          margin-top: 0.4rem;
        }
      }
    }
    .jieshun{
      @media screen and (max-width: 768px) {
        position: relative;
      }
    }
    .textual{
      @media screen and (max-width: 768px) {
        position: absolute;
        top: 0;
        height: 20rem;
        width: 100%;
      }
    }
    .profile-company{
      position: relative;
      margin-left:0!important;
      margin-right:40px;
      @media screen and (max-width: 768px) {
        padding: 0 0.5rem ;
        margin-top: 20rem !important;
      }
    }
  }
  .profile:after{
    content: "";
    display: block;
    clear: both;
  }
  //服务内容
  .service-content{
    .header{
      .title{
        font-size: $title-font-size;
        @media screen and (max-width: 768px) {
          font-size: $phone-title-font-size;
        }
      }
      .sub{
        font-size: $subtitle-font-size;
        @media screen and (max-width: 768px) {
          font-size: $phone-subtitle-font-size;
        }
      }
    }
    .service-info{
      display: flex;
      justify-content: center;
      .pc-img{
        display: flex;
        margin: 0 10%;
        @media screen and (max-width: 768px) {
          display: none;
        }
        img{
          height: 100%;
          width: 100%;
        }
      }
      .cell-phone{
        display: none;
        @media screen and (max-width: 768px) {
          display: flex;
          flex-direction: column;
          img{
            height: 10rem;
            width: 100%;
          }
        }
      }
    }
  }
  //我们代理、合作以下媒体
  .partners{
    display: flex;
    justify-content: center;
    margin:0 20%;
    aspect-ratio: auto 1200 / 338;
    height: 338px;
    aspect-ratio: auto 1200 / 338;
    @media screen and (max-width: 768px) {
      display: none;
    }
    img{
      height: 100%;
      width: 100%;
    }
  }
  //10大服务体现
  .service-system{
    display: flex;
    justify-content: center;
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  //对标上市企业
  .benchmarking{
    margin-left: 0;
    padding-top: 0.5rem;
    .header{
      .title{
        font-size: $title-font-size;
        @media screen and (max-width: 768px) {
          font-size: $phone-title-font-size;
        }
      }
      .sub{
        font-size: $subtitle-font-size;
        padding-bottom: 30px;
        @media screen and (max-width: 768px) {
          font-size: $phone-subtitle-font-size;
        }
      }
    }
  }
  .benchmarking:after{
    content: "";
    display: block;
    clear: both;
  }

}
</style>
